import { combineReducers } from 'redux'
import loginReducer from './reducers/loginReducer'

const rootReducer = combineReducers({
  user: loginReducer
})

export default rootReducer;